<!-- 获取白名单规则列表 -->
<template>
  <div class>
    <right-structure :Pdatas="infoData">
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: {
        parkCodeList: ["2KNTYVWC","2KNTYVCC"]
      },
      responseCode: {
        message: "业务成功",
        resultCode: 0,
        status: 1
      },
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台添新增白名单规则",
        t_url: this.commonUrls.test + "getRedList",
        p_url: this.commonUrls.prod + "getRedList",
         //precondition: {
         //   preData: "对接接口-",
         //   link:  "添加特殊车辆类型",
         //   url: "addSpecialCarType",
         //   endData: "，用于获取添加白名单所需要的specialCarTypeId（如已有请忽略）"
         // },
         // fitSystem: "VEMS传统停车场，云停车场",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "parkCodeList",
                info2: "是",
                info3: "String",
                info4:"停车场parkCode列表"
              }
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'data', info2: '否', info3: 'JSONArray', info4: '白名单列表'}
            ]
          },
          {
            titleName: "data",
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'id', info2: '是', info3: 'Long', info4: '规则ID'},
              {info1: 'redlistParam', info2: '是', info3: 'String', info4: '车牌号码或规则 如：指定某辆车 粤EJW123,如 *警，表示所有以 “警” 字结尾车辆都是白名单车辆'},
              {info1: 'parkNameList', info2: '是', info3: 'JSONArray', info4: '车场列表'},
              {info1: 'createTime', info2: '否', info3: 'yyyyMMddHHmmss', info4: '创建时间'}
            ]
          },
          {
            titleName: "parkNameList",
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码'},
              {info1: 'parkName', info2: '是', info3: 'String', info4: '车场名称'},
            ]
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
 /* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/redlist/getRedList.vue